module.exports = __webpack_public_path__ + "img/3_character.63a56b1a.png";